import cx               from 'classnames';
import { initStore }    from '../src/store';
import withRematch      from '../src/utils/withRematch';
import Layout           from '../src/containers/MineLayout';


const About = (props) => {
    let pageCSS = cx({
        page: true,
        defaultPage: true,
        About: true
    });

    const pageHeadStyle = {
        backgroundImage: 'url("/static/img/index-business/img_business@2x.png")'
    };

    return (
        <Layout {...props}>
            <div className={pageCSS}>
                <div className="default-head" style={pageHeadStyle}>
                    <div className="container">
                        <h1 className="default-header">МОБИЛЬНЫИ СЕРВИС ПО ГРУЗОПЕРЕВОЗКАМ №1</h1>
                    </div>
                </div>
                <div className="default-cnt">
                    <div className="container">
                        <div className="max-width">
                            <p>Мы живем в мегаполисе, это большой живой организм, который постоянно движется и не стоит на месте. В этом городе люди постоянно что-то перевозят, перемещают с места на место, для себя и для бизнеса – всё это происходит в атмосфере постоянной нехватки времени.</p>
                            <p>MOVER – ваш личный транспортный отдел. Платформа где вы без лишних вопросов получите профессиональную команду перевозчиков всего в пару кликов.</p>
                            <p>MOVER предостовляет вам огромные возможности для контроля, а вы сами решаете какой функционал вам нужен:</p>
                            <br />
                            <ul>
                                <li>Отслеживание перемещений автомобиля на осно- ве геолокации</li>
                                <li>Система уведомлений по всем статусам доставки</li>
                                <li>Страховка груза</li>
                                <li>Все способы оплаты</li>
                                <li>Экспедирование вашего груза</li>
                                <li>Возврат денег и документов</li>
                                <li>Услуги по погрузке и разгрузке</li>
                                <li>Детальная статистика по всем вашим перевозкам</li>
                                <li>Построение сложных маршрутов</li>
                            </ul>


                            <p>Даже если вы небольшой предприниматель с маленьким оборотом и неконтролируемым объемом доставок — MOVER лучший вариант для вас.</p>
                            <p>Вы самостоятельно оставляете за- явку на доставки своей продукции</p>
                            <p>Ближайший водитель принимает заказ и доставляет его</p>
                            <p>Никаких сложных переговоров, долгих подключений и переплат.</p>
                            <p>Доставляйте с MOVER просто!</p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

About.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});

    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: 'opacity',
        curLang,
        pathname,
        title: 'MOVER: О компании',
        description: 'Мы создали простой и понятный сервис заказа Грузового Такси в мегаполисах на стыке самых передовых технологий.  Благодаря MOVER любой городской житель сможет получить автомобиль самым быстрым способом и без переплат. Мы хотим что бы люди не тратили время на утомительный поиск перевозчика и организацию логистики для себя или в своём бизнесе. Благодаря MOVER, который решит все вопросы, больше не нужно воспринимать грузоперевозку как вынужденную проблему, а все свободное время посвятят близким или развитию своего бизнеса.'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(About);
